<template>
  <div class="customer-wrapper">
    <section class="menu-top">
      <div v-if="company" class="company-logo">
        <img :src="company.logo.lenght>0? company.logo[0]:'/img/default-logo.png'" alt class="logo" />
        <p v-if="company" class="company-name">{{company.company_name}}</p>
        <p v-if="menu" class="menu-name">{{menu.menu_name}}</p>
        <p v-if="menu" class="menu-description">{{menu.description}}</p>
        <div v-if="menu" class="categories">
          <scrollactive :offset="335" class="my-nav">
            <template v-for="(category) in categories">
              <a
                :href="`#${category.name}`"
                v-if="category.is_active===true"
                :key="category.id"
                class="scrollactive-item cat-box"
              >{{category.title}}</a>
            </template>
          </scrollactive>
        </div>
      </div>
    </section>

    <section v-if="menu" class="menu-body">
      <div
        class="no-data"
        v-if="menu.categories.length<1"
      >There are no items in this category yet. Click below to add item</div>
      <template v-else>
        <template v-for="(category) in categories">
          <template v-if="category.is_active">
            <CategoryCard
              :key="category.id"
              :index="category.id"
              :categories="categories"
              :menuId="menu.id"
              :category="category"
              :companyId="company.id"
            />
          </template>
        </template>
      </template>
    </section>
    <section class="waiter">
      <b-popover
        ref="popover"
        target="icon-btn"
        :show.sync="showPopover"
        placement="lefttop"
        triggers="click"
      >
        <template v-slot:title>
          <p class="text-center popover-title mb-0">Call a waiter</p>
        </template>
        <validation-observer v-if="!callingWaiter" v-slot="{invalid}">
          <TextInput
            :rules="'required'"
            type="number"
            placeholder="Enter table number"
            v-model="table.number"
          />
          <TextInput placeholder="Enter a message" v-model="table.message" />
          <Botton
            buttonClass="btn btn-primary d-flex btn-sm mx-auto"
            :disabled="invalid"
            text="Submit"
            :onclick="callWaiter"
            :isLoading="isCalling"
          />
        </validation-observer>
        <div v-else class="called-waiter text-center my-2">
          You requested for assistance and a notification has been sent. If you are not attended to within 5 minuties a reminder will be sent. If you have been attended to please end the request below
          <div class="d-flex">
            <Botton
              :onclick="endRequest"
              buttonClass="btn btn-danger  btn-sm mr-auto"
              text="End Request"
            />
            <Botton
              :onclick="onCloseWaiter"
              buttonClass="btn btn-primary btn-sm ml-auto"
              text="Ok"
            />
          </div>
        </div>
      </b-popover>

      <b-avatar id="icon-btn" class="icon-btn" button size="lg">
        <b-icon icon="bell-fill" :animation="callingWaiter?'throb':''"></b-icon>
      </b-avatar>
    </section>
    <section class="menu-footer">
      <p>copyright smart menu 2020</p>
    </section>
    <div @click="onCloseWaiter" v-if="showPopover" class="waiter-overlay"></div>
  </div>
</template>

<script>
import CategoryCard from "./components/customer/CategoryCard";
import TextInput from "./components/Inputs/TextInput";
import Botton from "./components/Botton";
import { ValidationObserver } from "vee-validate";
export default {
  components: {
    CategoryCard,
    TextInput,
    ValidationObserver,
    Botton
  },
  data() {
    return {
      username: null,
      menu_slug: null,
      table: {
        number: 0,
        message: ""
      },
      callingWaiter: false,
      isCalling: false,
      showPopover: false,
      menuOpen: true,
      notificationsOpen: false,
      
      collasped: true,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  methods: {
    async fetchMenu() {
      const response = await this.$store.dispatch("MenuView/getCurrentMenu", {
        username: this.username,
        menu_slug: this.menu_slug
      });
      this.fetchCategories();
    },
    async fetchCategories() {
      this.searchingCategories = true;
      const response = await this.$store.dispatch("Menu/fetchMenuCategories", {
        categories: this.menu.categories,
        companyId: this.company.id
      });
      this.searchingCategories = false;
      return response;
    },
    callWaiter() {
      this.isCalling = true;
      this.$store
        .dispatch("MenuView/callWaiter", {
          companyId: this.company.id,
          menuId: this.menu.id,
          table: this.table,
          companyName: this.username,
          menu_slug: this.menu_slug
        })
        .then(() => {
          this.isCalling = false;
          this.callingWaiter = true;
          localStorage.callingWaiter = this.callingWaiter;
          localStorage.table = JSON.stringify(this.table);
        });
    },

    endRequest() {
      this.$store
        .dispatch("MenuView/endRequest", {
          companyId: this.company.id,
          menuId: this.menu.id,
          table: this.table
        })
        .then(() => {
          localStorage.callingWaiter = false;
          this.callingWaiter = false;
          this.table.message = "";
          localStorage.table = JSON.stringify({ ...this.table });
          this.onCloseWaiter();
        });
    },

    onOpenWaiter() {
      this.$refs.popover.$emit("open");
    },
    onCloseWaiter() {
      this.$refs.popover.$emit("close");
    }
  },
  computed: {
    menu() {
      return this.$store.state.MenuView.currentMenu;
    },
    company() {
      return this.$store.state.MenuView.currentCompany;
    },
    categories() {
      return this.$store.state.Menu.menuCategories;
    }
  },
  mounted() {
    this.username = this.$route.params.username;
    this.menu_slug = this.$route.params.menu_slug;
    const localCallingWaiter = localStorage.callingWaiter
      ? JSON.parse(localStorage.callingWaiter)
      : false;
    if (localCallingWaiter) {
      this.callingWaiter = localStorage.callingWaiter;
      this.table = JSON.parse(localStorage.table);
    } else {
      this.callingWaiter = false;
      this.table = {
        number: 0,
        message: ""
      };
    }

    this.fetchMenu();
  }
};
</script>

<style>
</style>